<template>
  <Stack tag="div" gap="2xs" direction="col">
    <Button
      variant="secondary"
      size="sm"
      @click="handleBranchSelect"
      data-test-id="plpSelectBranchBtn"
      data-fs="plpSelectBranchBtn"
    >
      <template #before>
        <Icon name="branch" :size="16" />
      </template>
      Select a Branch
    </Button>

    <Text size="sm">to see available stock and prices</Text>
  </Stack>
</template>

<script lang="ts" setup>
import Button from "../Global/Button/Button.vue";
import Icon from "../Icon/Icon.vue";
import Stack from "../Layout/Stack/Stack.vue";
import Text from "../Typography/Text/Text.vue";

const emit = defineEmits(["cardBranchSelect"]);

const handleBranchSelect = () => {
  emit("cardBranchSelect");
};
</script>
